import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[bug]'
})
export class BugDirective {

    constructor(private el: ElementRef) { }

    @Input('bug') bugNumber: string;

    @HostListener('mousedown') onMouseDown() {
        window.open(`https://dev.azure.com/vs-research/Research/_workitems/edit/${this.bugNumber.toUpperCase()}`, '_new');
    }
}
